export default __webpack_public_path__ + "static/media/atend-logo.b607f5bd.png";